import { ImageGallery } from "./ImageGallery";
import { ImageGallerySkeleton } from "./ImageGallerySkeleton/ImageGallerySkeleton";
export { ImageGallerySkeleton };
export default ImageGallery;
